import { ItemsList } from '@wix/wix-ui-premium-purchase';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { RootStore, withInjectedRootStore } from 'providers';
import { PlanType } from 'enums';
import { FeatureTranslation, PlanFeaturesResponse } from 'types';
import Api from 'services/Api/Api';
import { Loader } from '@wix/design-system';

interface CurrentPlanFeaturesProps {
  rootStore: RootStore;
}

const CurrentPlanFeaturesComp: React.FC<CurrentPlanFeaturesProps> = ({
  rootStore,
}) => {
  const { currentPlanDetails } = rootStore.appStore.appContext;
  const { paymentCycle, planId } = currentPlanDetails!;
  const [loading, setLoading] = React.useState(true);
  const [planFeaturesAndSection, setPlanFeaturesAndSection] =
    React.useState<PlanFeaturesResponse | null>(null);
  const { t } = useTranslation();

  React.useEffect(() => {
    Api.getPlanFeatures({ planId, paymentCycle })
      .then((data) => {
        setPlanFeaturesAndSection(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [planId, paymentCycle]);

  if (!loading && planFeaturesAndSection) {
    const getTranslatedSections = () =>
      planFeaturesAndSection.sections.map(({ sectionName, features }) => ({
        sectionName: t(sectionName),
        items: features.map((feature: string | FeatureTranslation) => {
          let featureTranslation;
          if (typeof feature === 'string' || feature instanceof String) {
            featureTranslation = feature;
          } else {
            featureTranslation = feature.translation;
          }
          return featureTranslation
            .split('-')
            .map((_) => _.trim())
            .map(t)
            .join(' - ');
        }),
      }));
    const { isAdvance, type } = planFeaturesAndSection;
    const showSectionTitle = isAdvance && type === PlanType.Business;
    const translatedSections = getTranslatedSections();

    return (
      <ItemsList
        showSectionTitle={showSectionTitle}
        sections={translatedSections}
      />
    );
  }
  if (loading) {
    return <Loader />;
  }
  return null;
};

export default withInjectedRootStore(CurrentPlanFeaturesComp);
